import React, { useEffect } from "react";
import { useState } from "react";
// import "../../../Styles/landingpage.css";
import landingMob from "../../Images/finalcheck.webp"
import trustLogo from '../../Images/kalyan_logo.svg'
import RegisterForm from "./LandingPageComponents/RegisterForm";
import LoginForm from "./LandingPageComponents/LoginForm";
import "../../Styles/onlinesite.css";
import LoginPopup from "./LandingPageComponents/LoginPopup";
import ScriptInjector from "./LandingPageComponents/ScriptInjector";
import appStore from '../../Images/appstore.png'
import playStore from '../../Images/googleplay.png'
import helpIcon from '../../Images/Group 537.svg'
import landingPageImg from '../../Images/online-banner.webp'
import lakhAsProfile from "../../Images/lakhAsProfile.svg"
import familyMember from "../../Images/FamilyMember.svg"
import phoneNumberVerify from "../../Images/phoneNumberVerify.svg"
import basedMatches from "../../Images/basedMatches.png"
import parentsNumber from "../../Images/ParentsNumber.svg"
import friend from "../../Images/friend.svg"
import privacy from "../../Images/Privacy.svg"
import kalyanLogo from '../../Images/kalyanlogo123.webp'
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { use } from "i18next";
import Constants from "../../Constants/constants";

// import PasswordOpen from '../../Images/passwordeyeopen.png'

function LandingPage(props) {
  var loc = new URL(window.location.href);
  const baseUrl = `https://${loc.hostname}`;
  const apiBaseUrl = `${baseUrl}/api`;

  const [showLogin, setshowLogin] = useState(false);
  const [siteData, setSiteData] = useState(null);
  const [dropdownData, setDropdownData] = useState(null);
  const [showLoginPopup, setShowLoginPopup] = useState(false)


  
  useEffect(() => {
    // Apply background color when this page is mounted
    document.body.style.backgroundColor = "#ececec"; // Change to your desired color

    // Cleanup: Reset the background color when navigating away
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  useEffect(() => {
    function getSiteMapData() {
      let text = new URL(window.location.href);
      let dynamicURL = text.pathname.replace(/\/$/, ""); // Remove trailing slash if present

      fetch(`${apiBaseUrl}${dynamicURL}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data.status === "Success") {
            setSiteData(data.data);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    }
    getSiteMapData();
  }, []);
  const mobileNumber = localStorage.getItem("loginMobileNumber");
  const [preSelectedValues, setPreSelectedValues] = useState({}); // To store pre-selected values

  useEffect(() => {
    const getDropdownData = () => {
      fetch(`${apiBaseUrl}/registerdetails?mobileNumber=${mobileNumber}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          setDropdownData(data?.data)
          const preSelected = {
            countryId: data?.data?.country?.find((item) => item.selected === "Y")?.id || 499,
            motherTongueId: data?.data?.motherTongue?.find((item) => item.selected === "Y")?.id || "",
            religionId: data?.data?.religion?.find((item) => item.selected === "Y")?.id || "",
            profileId: data?.data?.profileFor?.find((item) => item.selected === "Y")?.id || "",
            denomination: data?.data?.domain?.find((item) => item.selected === "Y")?.id || "",
            phone: data?.data?.mobileNumber || "",
            email: data?.data?.email || "",
            name: data?.data?.name || "",
            gender: data?.data?.gender || "",
          };

          setPreSelectedValues(preSelected);
        })
        .catch((error) => {
          console.error("Error fetching dropdown data:", error);
        });
    };
    getDropdownData();
  }, [apiBaseUrl, mobileNumber]);

  const isCommunitySite = localStorage.getItem("IS_COMMUNITY_SITE");


  useEffect(() => {
    if (siteData) {
      setSiteData(siteData);
  
      // Remove existing scripts with class "pixelScript" to avoid duplicates
      // document.querySelectorAll(".pixelScript").forEach((el) => el.remove());
  
      // Create a container element to parse the `tag` string
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = `
        <meta class="pixelScript" name="description" content="${siteData?.description}" />
        <title class="pixelScript" th:text="${siteData?.title} "></title>
        <h1 class="matrimony-lang-headingv3 pixelScript" th:text="${siteData?.ptag}"></h1>
        ${siteData?.image ? `
          <div class="col-md-12 pixelScript">
            <img th:src="${siteData?.image}" alt="heading" />
          </div>` : ""}
        <div class="expectation pixelScript"><p th:text="${siteData?.h1}"></p></div>
      `;
  
      // Append each parsed element to <head>
      Array.from(tempDiv.children).forEach((child) => {
        document.head.appendChild(child);
      });
    }
  }, [siteData]);
  
//   const scriptToInject = `
//   <div class="pixelScript">
//     <!-- Google tag (gtag.js) -->
//     <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=AW-875555676"></script>
//     <script class="pixelScript">
//       window.dataLayer = window.dataLayer || [];
//       function gtag(){dataLayer.push(arguments);}
//       gtag('js', new Date());
    
//       gtag('config', 'AW-875555676');
//     </script>
  
//   <!-- Google tag (gtag.js) -->
//   <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=G-G4GYGWS9XB"></script> 
//   <script class="pixelScript"> window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-G4GYGWS9XB'); </script>
//   <div/>
//   `
  

//   useEffect(() => {
//     if (!isCommunitySite) {
//       // Remove existing scripts with class "pixelScript"
//       const existingScripts = document.querySelectorAll('.pixelScript');
//       existingScripts.forEach(script => script.remove());

//       // Create a temporary container to parse the scriptToInject string
//       const tempDiv = document.createElement('div');
//       tempDiv.innerHTML = scriptToInject;

//       // Append each script element to the head
//       const scripts = tempDiv.querySelectorAll('script');
//       scripts.forEach(script => {
//         script.classList.add('pixelScript');
//         document.head.appendChild(script);
//       });
//     }
// },[])

const [scriptToInject, setScriptToInject] = useState("");

  useEffect(() => {
    const currentPath = window.location.pathname;

    // <script src="https://static-cdn.trackier.com/rtg/67ea8c9c897d0354893ccb84.js"></script>
    
    if (currentPath.includes("/online-matrimony-website/")) {
      setScriptToInject(`
        <div class="pixelScript">
          <!-- Google tag (gtag.js) -->
          <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=AW-875555676"></script>
          <script class="pixelScript">
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'AW-875555676');
          </script>
          <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=G-G4GYGWS9XB"></script>
          <script class="pixelScript">
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'G-G4GYGWS9XB');
          </script>
          

          <!-- Taboola Pixel Code -->
      <script type='text/javascript'>
        window._tfa = window._tfa || [];
        window._tfa.push({notify: 'event', name: 'page_view', id: 1728611});
        !function (t, f, a, x) {
              if (!document.getElementById(x)) {
                  t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
              }
        }(document.createElement('script'),
        document.getElementsByTagName('script')[0],
        '//cdn.taboola.com/libtrc/unip/1728611/tfa.js',
        'tb_tfa_script');
      </script>
      <!-- End of Taboola Pixel Code -->
        </div>
      `);
    }
    else if (currentPath.includes("/online-matrimony-site")) {

      setScriptToInject(`
         <div class="pixelScript">
          <!-- Google tag (gtag.js) -->
          <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=AW-875555676"></script>
          <script class="pixelScript">
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'AW-875555676');
          </script>
          <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=G-G4GYGWS9XB"></script>
          <script class="pixelScript">
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('configooo', 'G-G4GYGWS9XB');
          </script>

          <!-- Quora Pixel Code (JS Helper) -->
          <script>

          !function(q,e,v,n,t,s){if(q.qp) return; n=q.qp=function(){n.qp?n.qp.apply(n,arguments):n.queue.push(arguments);}; n.queue=\[];t=document.createElement(e);t.async=!0;t.src=v; s=document.getElementsByTagName(e)\[0]; s.parentNode.insertBefore(t,s);}(window, 'script', 'https://a.quora.com/qevents.js');
          qp('init', '5f68ebb3f58e4454a24d4e00b4db8248');
          qp('track', 'ViewContent');
          <noscript><img height="1" width="1" style="display:none" src="https://q.quora.com/\_/ad/5f68ebb3f58e4454a24d4e00b4db8248/pixel?tag=ViewContent\&noscript=1"/></noscript>
          <!-- End of Quora Pixel Code -->

        </div>
      `);
    }
     else {
      setScriptToInject(`
        <div class="pixelScript">
          <!-- Google tag (gtag.js) -->
          <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=AW-875555676"></script>
          <script class="pixelScript">
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'AW-875555676');
          </script>
          <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=G-G4GYGWS9XB"></script>
          <script class="pixelScript">
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('configooo', 'G-G4GYGWS9XB');
          </script>
        </div>
      `);
    }
  }, []);

// const scriptToInjectss = `
//   <div class="pixelScript">
 
//          <!-- Google tag (gtag.js) -->
//         <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=AW-875555676"></script>
//         <script class="pixelScript">
//          window.dataLayer = window.dataLayer || [];
//          function gtag() { dataLayer.push(arguments); }
//          gtag('js', new Date());
 
//          gtag('config', 'AW-875555676');
//         </script>
//         <!-- Google tag (gtag.js) -->
//         <script class="pixelScript" async src="https://www.googletagmanager.com/gtag/js?id=G-G4GYGWS9XB"></script>
//         <script class="pixelScript"> window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('js', new Date()); gtag('config', 'G-G4GYGWS9XB');</script>
//   </div>`
  
const [searchParams, setSearchParams] = useSearchParams();
const navigate = useNavigate();
const [nextPage, setNextPage] =useState();
let text = new URL(window.location.href);


useEffect(() => {
  if (text.pathname === "/loginfromuploadpartial") {
    const jwt = searchParams.get("jwt");
    const utm_source = searchParams.get("utm_source");
    const utm_medium = searchParams.get("utm_medium");
    const utm_campaign = searchParams.get("utm_campaign");

             localStorage.setItem(Constants.loginLocalStorageKeys.utmSource, searchParams.get("utm_source") ?? "meta");
             localStorage.setItem(Constants.loginLocalStorageKeys.utmMedium, searchParams.get("utm_medium") ?? "meta_wp");
             localStorage.setItem(Constants.loginLocalStorageKeys.utmCampaign, searchParams.get("utm_campaign") ?? "leadform_");

    if (jwt && utm_source && utm_medium && utm_campaign) {
      const apiUrl = `/api/loginfromuploadpartial?jwt=${encodeURIComponent(jwt)}&utm_source=${encodeURIComponent(utm_source)}&utm_medium=${encodeURIComponent(utm_medium)}&utm_campaign=${encodeURIComponent(utm_campaign)}`;

      axios.get(apiUrl)
        .then(response => {
          const data = response.data;
          if (data.status === "Success" && data.data?.nextPage) {
            localStorage.setItem("netpage", data.data.nextPage);
            setNextPage(data.data.nextPage);
            localStorage.setItem(Constants.loginLocalStorageKeys.loginMobileNumber,data.data.mobileNumber ?? "")
            localStorage.setItem("nextpage", data.data.nextPage);
            // window.location.href = "/online-matrimony-site";
            navigate("/online-matrimony-site");
          } else {
            alert("Login failed");
          }
        })
        .catch(error => {
          console.error("API error:", error);
        });
    }
  }
}, [searchParams]);

const loginNextPage = localStorage.getItem("nextpage");


window.onload = function() {
  localStorage.removeItem("nextpage");
};

useEffect(() => {
  const handleUnload = () => {
    localStorage.removeItem("nextpage");
  };
  window.addEventListener("beforeunload", handleUnload);
  return () => window.removeEventListener("beforeunload", handleUnload);
}, []);

  return (
    <>
        {showLoginPopup && <LoginPopup dropdownData={dropdownData} onClose={()=>setShowLoginPopup(false)}/>}
{!isCommunitySite && scriptToInject && <ScriptInjector scriptHtml={scriptToInject} />}
    
    <div class="font-segeo divcontain" style={{backgroundColor: 'white'}}>
      {/* {!siteData && (
        <div id="loader" className="loaderBg">
          <img alt="loader" src="/Assets/Gif/loader.gif" className="loaderGif" />
        </div>
      )} */}
        <header class="header">
          <div class="header-display-web">
            <div class="header-container">
              <div class="container-header">
                  <a href="" class="logo">
                  <img
                      width="210"
                      height="60"
                      src={kalyanLogo}
                      className="logo img"
                      alt=""
                  />
                  </a>
                  <div class="logo-container">

                      <img
                          width="38"
                          height="50"
                          src={trustLogo}
                          className="logo-img"
                          alt=""
                      />
                      <div class="text-container">
                          <p class="kalyan-text-style">
                              From the Trusted Brand <br />
                              <span class="jew-text-style">Kalyan Jewellers</span>
                          </p>
                      </div>
                  </div>   
              </div>
                  
              <div class="flex-container" >
                  
                      <LoginForm pathname={loginNextPage} apiBaseUrl={apiBaseUrl} isFromLandingPage={true}  dropdownData={dropdownData}/>
                 
                  <div class="app-section">
                      <p class="download-text">Download our App</p>
                      <div class="app-links">
                        <a href="https://play.google.com/store/apps/details?id=com.kalyanmatrimony.app" target="_blank">
                            <img src={playStore} alt="Google Play" style={{height: "2.2rem", width: "7rem"}}/>
                        </a>
                        <a href="https://apps.apple.com/in/app/kalyan-matrimony-marriage-app/id6478538275" target="_blank">
                            <img src={appStore} alt="App Store" style={{height: "2.2rem", width: "7rem"}}/>
                        </a>
                      </div>
                      <p class="gold-scheme">
                        <a href="/gold-saving-scheme-online" target="_blank">Buy Gold Saving Scheme Online</a>
                      </p>
                  </div>
                  
                  <div class="help-section">
                      <a href="/contact-us-for-help">
                          <img src={helpIcon} alt="Help" style={{ height: '2.2rem', width: '2.2rem' }}/> 
                          <br /> 
                      </a>
                      <span>Help</span>
                  </div>
              </div>
              
            </div>
            <div class="separator rounded"></div>
          </div>
            
          <div class="header-display-mob">

            <div class="container-header">
                <a href="" class="">
                    <img
                        width="150"
                        height="60"
                        src={kalyanLogo}
                        class=""
                        alt=""
                    />
                </a>
            
                <div class="logo-container">
                    <a href="" class="logo">
                        <img
                          src={trustLogo}
                          class="logo-img"
                          alt=""
                          width="20"
                          height="10"
                        />
                    </a>
                    <div class="text-container">
                        <p class="kalyan-text-style" style={{fontSize: '11px'}}>
                            From the Trusted Brand <br />
                            <span class="jew-text-style" style={{fontSize: '9px'}}>Kalyan Jewellers</span>
                        </p>
                    </div>
                </div>                                    
            </div>
            <div class="separator"></div>
            <div class="separator-rounded"></div>
                
          </div>
        </header>
        <div className="webview" style={{backgroundColor: 'white'}}>
          <div class="container-main">
            <div class="header">
                <h2>Find your Perfect Match from Lakhs of Profiles in Top Communities – Trusted by Families and Easy to use.</h2>
            </div>
            
            <div class="content" style={{backgroundColor: 'white'}}>
                <img src={landingPageImg} alt="main"/>
            </div>
            
            <div class="menu" style={{backgroundColor: 'white'}}>
              <div class="lakhs-text">
                <p class="findLakhofProfile">Find Lakhs of Profiles</p>
              </div>
              <div className="form">
                <div className=" register2">
                  <button onClick={() => setshowLogin(false)} className={`button1 ${showLogin ? "" : "activeButton"}`}>REGISTER</button>
                  <button onClick={() => setshowLogin(true)} className={`button2 ${showLogin ? "activeButton" : ""}`}>SIGN IN</button>
                </div>
                <div className="App">
                  {/* <div className="App" style={{width: '18rem'}}> */}
                    <div
                      style={{ display: showLogin ? "none" : "block"}}
                    > 
                      <RegisterForm
                        apiBaseUrl={apiBaseUrl}
                        dropdownData={dropdownData}
                        isFromLandingPage={true}
                        preSelectedValues={preSelectedValues}
                        pathname={loginNextPage}
                      />
                    </div>
                    <div
                      style={{ display: showLogin ? "block" : "none" }}
                    >
                      <LoginForm
                        apiBaseUrl={apiBaseUrl}
                        dropdownData={dropdownData}
                        pathname={loginNextPage}
                      />
                    </div>
                  {/* </div>  */}
                </div>
              </div>

            </div>

            <div class="footer" style={{backgroundColor: 'white'}}>
              <div class="why-choose-section" style={{paddingLeft: '20px !important', paddingRight: '20px', paddingBottom: '20px'}}>
                  <h2 class="">Why choose Kalyan Matrimony</h2>
                  <div class="why-choose-container">

                      <div class="why-choose-item-trust">
                        <img src={trustLogo} alt="Trusted Brand" className="trust"/>
                        <p>From the Trusted Brand Kalyan Jewellers</p>
                      </div>
                      <div class="why-choose-item">
                        <img src={lakhAsProfile} alt="Lakhs of Profiles" />
                        <p>Lakhs of Profiles</p>
                      </div>
                      <div class="why-choose-item">
                        <img src={basedMatches} alt="AI-Based Matches" />
                        <p>AI-Based Matches</p>
                      </div>
                      <div class="why-choose-item">
                        <img src={phoneNumberVerify} alt="Phone Verified" />
                        <p>Phone Number Verified Profiles</p>
                      </div>
                      <div class="why-choose-item">
                        <img src={parentsNumber} alt="Parent's Number" />
                        <p>Parent's number in most profiles</p>
                      </div>
                      <div class="why-choose-item">
                        <img src={familyMember} alt="Family Login" />
                        <p>Family members can login</p>
                      </div>
                      <div class="why-choose-item">
                        <img src={friend} alt="Family Login" />
                        <p>User-Friendly Interface</p>
                      </div>
                      <div class="why-choose-item">
                        <img src={privacy} alt="Family Login" />
                        <p>Privacy and Security</p>
                      </div>
                  </div>
              </div>
              <div class="footer-section" style={{fontSize: '16px !important', borderRadius: '10px 10px 0px 0px'}}>
                  Kalyan Matrimony is a trusted matrimonial service designed for those seeking a lifelong marriage.This is not a dating website. 
                  <br /> All profiles should reflect genuine marriage intentions. Copyright © 2025 Kalyan Matrimony. All rights reserved.
              </div>
            </div>
          </div>
        </div>
        
        <div class="mobile ">
          <div>
            <p style={{textAlign: 'center', fontWeight: 600}} className="heading">Find your Perfect Match from Lakhs of Profiles in Top Communities <br /> – Trusted by Families and Easy to use.</p>
          </div>
          <div>

              <div style={{paddingLeft: '1rem',paddingRight: '1rem'}}>

                <img
                  src="/finalcheck.webp"
                  alt="Landing"
                  width="350"
                  height="284"
                  loading="eager"
                  fetchpriority="high"
                  style={{objectFit: 'cover', width: '100%', height: 'auto'}}
                />
                 
              </div>
              
              
              <div class="form-padding">
                  <div class="lakhs-text">
                      <p class="findLakhofProfile">Find Lakhs of Profiles</p>
                  </div>
              
                  <div class="form">
                      <div className=" register2">
                        <button onClick={() => setshowLogin(false)} className={`button1 ${showLogin ? "" : "activeButton"}`}>REGISTER</button>
                        <button onClick={() => setshowLogin(true)} className={`button2 ${showLogin ? "activeButton" : ""}`}>SIGN IN</button>
                      </div>
                      <div className="App">
                          <div
                              id="myForm-mobile"
                              className=""
                              style={{ display: showLogin ? "none" : "block"}}
                          >
                              <RegisterForm
                                  apiBaseUrl={apiBaseUrl}
                                  dropdownData={dropdownData}
                                  preSelectedValues={preSelectedValues}
                                  pathname={loginNextPage}
                              />
                          </div>
                          <div
                              id="loginForm-mobile"
                              className=""
                              style={{ display: showLogin ? "block" : "none" }}
                          >
                              <LoginForm
                                  apiBaseUrl={apiBaseUrl}
                                  dropdownData={dropdownData}
                                  pathname={loginNextPage}
                              />
                          </div>
                      </div>
                  </div>
              </div>

              <div class="why-choose-section">
                  <h2 class="why-choose-heading">Why choose Kalyan Matrimony</h2>
                  <div class="why-choose-container">

                      <div class="why-choose-item-trust">
                      <img loading="lazy" src={trustLogo} alt="Trusted Brand" className="trust"/>
                      <p>From the Trusted Brand<br />Kalyan Jewellers</p>
                      </div>
                      <div class="why-choose-item">
                          <img loading="lazy" src={lakhAsProfile} alt="Lakhs of Profiles" />
                          <p>Lakhs of Profiles</p>
                      </div>
                      <div class="why-choose-item">
                          <img loading="lazy" src={basedMatches} alt="AI-Based Matches" />
                          <p>AI-Based Matches</p>
                      </div>
                      <div class="why-choose-item">
                          <img loading="lazy" src={phoneNumberVerify} alt="Phone Verified" />
                          <p>Phone Number Verified Profiles</p>
                      </div>
                      <div class="why-choose-item">
                          <img loading="lazy" src={parentsNumber} alt="Parent's Number" />
                          <p>Parent's number in most profiles</p>
                      </div>
                      <div class="why-choose-item">
                      <img loading="lazy" src={familyMember} alt="Family Login" />
                          <p>Family members can login</p>
                          </div>
                      <div class="why-choose-item">
                          <img loading="lazy" src={friend} alt="Family Login" />
                          <p>User-Friendly Interface</p>
                      </div>
                      <div class="why-choose-item">
                          <img loading="lazy" src={privacy} alt="Family Login" />
                          <p>Privacy and Security</p>
                      </div>
                  </div>
              </div>
                

              <div class="footer-section">
                <p>Kalyan Matrimony is a trusted matrimonial service designed for those seeking a lifelong marriage. This is not a dating website. 
                  All profiles should reflect genuine marriage intentions.
                  Copyright © 2025 Kalyan Matrimony. All rights reserved.</p>
              </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LandingPage;
